import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { InformationPageField } from 'queries';
import { CustomFormFieldSubmitButton } from '../components/CustomFormFieldSubmitButton';
import { useTranslation } from 'react-i18next';
import { SubmitType } from '../fieldConfigurations';
import { FieldNumber } from '../components/FieldNumber';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
  },
  title: {
    ...theme.fonts.h3,
    whiteSpace: 'pre-line',
  },
  description: {
    ...theme.fonts.body,
    color: theme.colors.inkSecondary,
    marginTop: theme.marginBase * 3,
  },
  childrenContainer: {
    marginLeft: theme.marginBase,
  },
  numberContainer: {
    marginLeft: -theme.marginBase * 2,
  },
}));

interface Props {
  field: InformationPageField;
  onSubmit?: () => any;
  isPreview?: boolean;
  submitType?: SubmitType;
  fieldNumber?: number;
}

export const InformationPage = ({
  field,
  onSubmit,
  isPreview,
  submitType,
  fieldNumber,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();
  return (
    <div className={classes.container}>
      {fieldNumber && (
        <div className={classes.numberContainer}>
          <FieldNumber number={fieldNumber} />
        </div>
      )}
      <div className={classes.childrenContainer}>
        <h1 className={classes.title}>
          {field.title || t('screeningForm.noQuestion')}
        </h1>
        {field.properties && field.properties.description && (
          <p className={classes.description}>{field.properties.description}</p>
        )}
        {!isPreview && (
          <CustomFormFieldSubmitButton
            onClick={() => onSubmit && onSubmit()}
            submitType={submitType}
          />
        )}
      </div>
    </div>
  );
};
